import { render, staticRenderFns } from "./Nomenclature.vue?vue&type=template&id=6345d07a&scoped=true&"
import script from "./Nomenclature.vue?vue&type=script&lang=ts&"
export * from "./Nomenclature.vue?vue&type=script&lang=ts&"
import style0 from "./Nomenclature.vue?vue&type=style&index=0&id=6345d07a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6345d07a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
